const htmlTag = document.querySelector('html');
const bodyTag = document.querySelector('body');

export const localeRoot = htmlTag.dataset.localeroot ?? '/';
export const currencyCode = bodyTag.dataset.currencycode ?? 'GBP';
export const currencyCodeLocale = bodyTag.dataset.currencycodelocale ? bodyTag.dataset.currencycodelocale.replace('_','-') : 'en-GB';
